<script lang="ts">
  import { copy } from '../lib/stores/copy';
  import { storeSelector } from "../lib/helpers/countryStore";
  import { countryStore } from "../lib/stores/country";
  import { isPrimaryCampaign } from '../lib/constants/countries';

  export let title: string;
  export let subtitle: string;
</script>

<main class="flex flex-col grow relative bg-dark bg-[url('/bg/mobile-bg4.webp')] tablet:bg-[url('/bg/main-bg.webp')] tablet:min-h-[47vw] items-center tablet:items-start bg-cover bg-[center_calc(100%_+_40vw)] tablet:bg-center pb-[calc(105vw-108px-1rem)] tablet:pb-0">
  <div class="relative flex grow justify-center text-center w-[calc(100%-2rem)] tablet:items-center tablet:w-[72vw]">
    <div class="px-0 py-8 mobile:px-8 mobile:py-8 bg-black/50 rounded-md my-4 w-full tablet:w-auto mb-[calc(118px+1rem)] laptop:mb-4">
      <h1 class="font-MrEavesXLSanNarOTUltra text-primary leading-[0.75] uppercase text-[56px] mobile:text-[68px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]">
        {@html title}
      </h1>
      <h2 class="font-MrEavesXLSanNarOTUltra text-[19px] leading-[1] uppercase text-white font-black tablet:text-[24px] laptop:text-[29px] desktop:text-[32px] desktopLg:text-[40px]">
        {@html subtitle}
      </h2>
      {#if isPrimaryCampaign}
        <div class="flex items-center justify-center mt-[20px] tablet:mt-[52px]">
          <button
            on:click={() => storeSelector($countryStore)}
            class="std-button font-MrEavesXLSanNarOTUltra relative inline-flex justify-center items-center text-[16px] whitespace-nowrap text-white px-[12px] uppercase h-[42px] min-w-[132px] bg-dark border-solid border-white border-2 no-underline uppercase transition cursor-pointer overflow-hidden tablet:text-[18px] tablet:h-[48px]">
            <span class="relative z-[1]">
              {@html $copy.header.menus.orderFromLittleCaesars}
            </span>
          </button>
        </div>
      {/if}
    </div>
  </div>
</main>
